import { render, staticRenderFns } from "./specified-offer.vue?vue&type=template&id=07876388&scoped=true&"
import script from "./specified-offer.vue?vue&type=script&lang=js&"
export * from "./specified-offer.vue?vue&type=script&lang=js&"
import style0 from "./specified-offer.vue?vue&type=style&index=0&id=07876388&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07876388",
  null
  
)

export default component.exports